import * as React from 'react';
import Box from '../components/primitives/Box';
import styled from 'styled-components';
import { StyledSystemProps } from '../theme/StyledSystemProps';
import { Spring, animated } from 'react-spring/renderprops.cjs';

const StyledBox = styled(animated(Box))`
  box-shadow: 0 0px 4px -1px rgba(50, 50, 93, 0.3);
  transition: all 0.2s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  background-color: ${props => props.background};
  @media screen and (max-width: 1024px) {
    min-width: 300px;
    max-width: 100%;
  }
`;

type CardProps = StyledSystemProps & {
  className?: string;
  color?: string;
  boxSizing?: string;
  minHeight?: string;
  onClick?: () => void;
  children: React.ReactNode;
};

const Card: React.FC<CardProps> = props => (
  <Spring
    config={{ tension: 200, friction: 30 }}
    from={{ opacity: 0, transform: 'translateY(30px)' }}
    to={{ opacity: 1, transform: 'translateY(0)' }}
  >
    {styleProps => (
      <StyledBox style={styleProps} onClick={props.onClick} {...props}>
        {props.children}
      </StyledBox>
    )}
  </Spring>
);

Card.defaultProps = {
  bg: '#FFF',
  borderRadius: '4px',
  boxShadow: '0 2px 5px rgba(0, 0, 0, 0.3)',
  boxSizing: 'border-box',
  minHeight: '100px',
  onClick: () => null,
  p: '20px',
  width: 'auto',
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/Card.tsx